import React, { Component } from 'react'
import { Route, withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import InvoiceList from './InvoiceList'
import Invoice from './Invoice'

class InvoicePage extends Component {
  static propTypes = {
    match: PropTypes.object,
    invoiceType: PropTypes.number.isRequired,
    project: PropTypes.object,
    contract: PropTypes.object
  }

  render () {
    const { match, invoiceType, project, contract } = this.props
    const invoiceRoute = match.url

    return (
      <div>
        <Route
          exact
          path={invoiceRoute}
          render={props => (
            <InvoiceList
              {...props}
              invoiceType={invoiceType}
              project={project}
              contract={contract}
            />
          )}
        />

        <Route
          exact
          path={invoiceRoute + '/:id'}
          render={props => (
            <Invoice
              key={props.match.params.id}
              {...props}
              invoiceType={invoiceType}
              project={project}
              contract={contract}
            />
          )}
        />
      </div>
    )
  }
}

export default withRouter(inject('invoiceStore')(observer(InvoicePage)))
